/* Persists UTM/click-id attribution across page views (first-touch + last-touch)
   and a stable anonymous visitor id, so quote/contact forms can attach
   accurate marketing attribution even when the user lands on a different
   page than the one their ad/link pointed to. */
(function () {
  function getCookie(name) {
    var match = document.cookie
      .split('; ')
      .find(function (c) { return c === name || c.indexOf(name + '=') === 0; });
    if (!match) return null;
    var value = match.slice(name.length + 1);
    try { return decodeURIComponent(value); } catch (e) { return value; }
  }

  function setCookie(name, value, days) {
    var expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + expires.toUTCString() + ';path=/';
  }

  function generateId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'aid-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  }

  function getReferrerTouch() {
    if (!document.referrer) return { source: null, medium: null };
    try {
      var refHost = new URL(document.referrer).hostname.replace(/^www\./, '');
      var currentHost = window.location.hostname.replace(/^www\./, '');
      if (refHost === currentHost) return { source: null, medium: null };
      return { source: refHost, medium: 'referral' };
    } catch (e) {
      return { source: null, medium: null };
    }
  }

  function readTouchFromParams(params) {
    var hasGoogleClickSignals = Boolean(
      params.get('gclid') || params.get('gad_source') || params.get('gad_campaignid')
    );
    var source = params.get('utm_source') || (hasGoogleClickSignals ? 'google' : null);
    var medium = params.get('utm_medium') || (hasGoogleClickSignals ? 'paid' : null);
    var clickId = params.get('fbclid') || params.get('gclid') || params.get('gad_campaignid') || null;

    if (!source) {
      var refTouch = getReferrerTouch();
      source = refTouch.source;
      medium = medium || refTouch.medium;
    }

    return {
      source: source,
      medium: medium,
      campaign: params.get('utm_campaign'),
      term: params.get('utm_term'),
      content: params.get('utm_content'),
      clickId: clickId
    };
  }

  function hasAnyValue(touch) {
    return Object.keys(touch).some(function (key) { return touch[key] !== null; });
  }

  function ensureAnonymousId() {
    var id = getCookie('aid_anonymous_id');
    if (!id) {
      id = generateId();
      setCookie('aid_anonymous_id', id, 365);
    }
    try { window.localStorage.setItem('anonymousId', id); } catch (e) {}
    return id;
  }

  function persistTouches() {
    var params = new URLSearchParams(window.location.search);
    var touch = readTouchFromParams(params);
    if (!hasAnyValue(touch)) return;

    setCookie('aid_last_touch', JSON.stringify(touch), 30);

    if (!getCookie('aid_first_touch')) {
      setCookie('aid_first_touch', JSON.stringify(touch), 365);
    }
  }

  function readTouchCookie(name) {
    var raw = getCookie(name);
    if (!raw) return {};
    try { return JSON.parse(raw); } catch (e) { return {}; }
  }

  function getTrackingData() {
    var anonymousId = ensureAnonymousId();
    var firstTouch = readTouchCookie('aid_first_touch');
    var lastTouch = readTouchCookie('aid_last_touch');

    return {
      anonymousId: anonymousId,
      firstSource: firstTouch.source || null,
      firstMedium: firstTouch.medium || null,
      firstCampaign: firstTouch.campaign || null,
      lastSource: lastTouch.source || null,
      lastMedium: lastTouch.medium || null,
      lastCampaign: lastTouch.campaign || null,
      clickId: lastTouch.clickId || firstTouch.clickId || null,
      referrer: document.referrer || lastTouch.source || null
    };
  }

  persistTouches();
  ensureAnonymousId();

  window.FineystAttribution = { getTrackingData: getTrackingData };
})();
